/**
 * When linking to support docs from inside our app, this lets us keep our links
 * clean and in one place.
 */
export const docs = {
  home: "https://support.replo.app",
  analytics: {
    howToDriveTraffic:
      "https://www.youtube.com/watch?v=zkaU86jbfC4&list=PLfnuyugbVrd9pogLxkWVUrrFNDKhteSzl&index=6",
  },
  insights: {
    feedbackForm:
      "https://airtable.com/appa1xcnGh0erPqfh/pagc3qrh9UUy8Sh6P/form",
    improvementSuggestions:
      "https://www.youtube.com/watch?v=QLKXXU6FJUA&list=PLfnuyugbVrd9pogLxkWVUrrFNDKhteSzl&index=7",
  },
  abTesting: {
    main: "https://support.replo.app/hc/en-us/articles/20693018801549",
    analytics:
      "https://support.replo.app/hc/en-us/articles/20693018801549#h_01HDJ5HA9VHCF2WMX46Q7SHHTG",
    metricDefinitions:
      "https://support.replo.app/articles/7994386701-replo-analytics-metric-definitions",
    workspaceCustomDomains:
      "https://support.replo.app/articles/2069301880-experiments-(a/b-testing)#how-to-use-replo-experiments-12",
    education: {
      getStarted: "https://youtu.be/liC0cwf2Oks",
      exploreTopTests: "https://www.replo.app/ab-testing-examples",
      whyABTestingWorks: "https://www.replo.app/ab-testing",
      frequentlyAskedQuestions:
        "https://support.replo.app/articles/7496318005-replo-a-b-testing-faqs",
      statSigCalculator:
        "https://www.replo.app/cro-resources/shopify-a-b-testing-significance-calculator-v2",
    },
  },
  klaviyo: "https://support.replo.app/hc/en-us/articles/17512842513165-Klaviyo",
  templateDefaults:
    "https://support.replo.app/hc/en-us/articles/20118402411021",
  sellingPlans: {
    thirdPartyAtc:
      "https://support.replo.app/articles/1716416054-subscriptions-and-selling-plans#allowing-third-party-apps-to-override-selling-plan-selections-16",
  },
  editorContentTypes: {
    pages: "https://docs.replo.app/docs/content-types/pages",
    shopifySections:
      "https://docs.replo.app/docs/content-types/shopify-sections",
    productTemplates:
      "https://support.replo.app/hc/en-us/articles/17881635030797-Product-Templates",
  },
  dynamicData:
    "https://support.replo.app/hc/en-us/articles/17131155971213-Dynamic-Data",
  permissions:
    "https://support.replo.app/hc/en-us/articles/25180416846861-Permissions-In-Replo",
  swatches: "https://docs.replo.app/docs/building/swatches",
  faq: "https://docs.replo.app/docs/getting-started/faq",
  shopifyMaxProductsOnPage:
    "https://support.replo.app/articles/8672651932-how-many-shopify-products-can-be-on-one-page",
  multiCanvas:
    "https://support.replo.app/articles/5169277701-multi-device-editing",
  billingPlans:
    "https://support.replo.app/articles/2238970734-what-replo-plan-is-right-for-me",
  dataAttributes:
    "https://support.replo.app/articles/1799213363-custom-development-with-replo#adding-data-attributes-to-replo-dom-nodes-18",
  errors: {
    wrongJsonExtension:
      "https://support.replo.app/articles/9676650469-i-see-an-error-that-says-the-template-for-this-content-in-shopify-has-been-manually-changed-from-liquid-to-json",
    imageSourceTooLong:
      "https://support.replo.app/articles/1168122633-why-am-i-getting-an-image-source-error",
    chunkingError:
      "https://support.replo.app/articles/4458256377-why-am-i-getting-a-liquid-content-present-that-is-too-large-error",
    indexBackupError:
      "https://support.replo.app/articles/5206098091-why-am-i-getting-a-failed-to-backup-homepage-template-error",
    shopifyIntegrationAlreadyAssigned:
      "https://support.replo.app/articles/1713040192-integrating-shopify",
    projectConnectedToBillingIntegrationForShopifyWorkspace:
      "https://support.replo.app/articles/1713047246-workspaces%2C-projects%2C-and-members-in-replo#handling-errors-36",
    themeAssetSizeLimitExceeded:
      "https://support.replo.app/articles/5420749840-i-see-an-error-that-says-one-of-the-files-that-would-be-published-exceeds-the-limit-allowed-by-shopify",
    themeTotalSizeLimitExceeded:
      "https://support.replo.app/articles/9258604529-i-see-an-error-that-says-your-store-s-theme-exceeds-the-size-allowed-by-shopify",
    themeLayoutNotSupported:
      "https://support.replo.app/articles/6824875055-i-see-an-error-that-says-unable-to-show-theme-header-and-footer",
    pageMetafieldDefinitionsChanged:
      "https://support.replo.app/articles/8078136824-i-see-an-error-that-says-page-metafield-definitions-have-changed",
  },
  warnings: {
    cannotRenameSection:
      "https://support.replo.app/articles/1716492430-shopify-sections#renaming-sections-54",
  },
  leftBar: {
    savedStyles: "https://support.replo.app/articles/6084305582-saved-styles",
    insert: "https://support.replo.app/collections/8618926849-components",
    elements: "https://support.replo.app/collections/9149515681-content-types",
  },
  modifiers: {
    text: "https://support.replo.app/articles/6715966694-text-modifier",
  },
  multiSelect: {
    main: "https://support.replo.app/articles/3149142653-selecting-multiple-components-beta",
    multipleStates:
      "https://support.replo.app/articles/3149142653-selecting-multiple-components-beta#editing-multiple-states-3",
  },
  savedStyles: {
    main: "https://support.replo.app/articles/6084305582-saved-styles",
    text: "https://support.replo.app/articles/6084305582-saved-styles#text-styles-3",
    color:
      "https://support.replo.app/articles/6084305582-saved-styles#color-styles-6",
  },
  ai: "https://www.replo.app/product/content-ai",
  bundleBuilder:
    "https://support.replo.app/articles/3710737591-bundle-builders-in-replo",
};
